/**
 * Playlists switcher — pick which assigned playlist is active.
 */
import React from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { ListVideo, ArrowLeft, CheckCircle2 } from "lucide-react";
import { PLAYER } from "../lib/testIds";

export default function PlaylistsSwitcher() {
  const navigate = useNavigate();
  const { playlists, activePlaylistId, setActivePlaylistId } = useOutletContext();

  const pick = (id) => {
    setActivePlaylistId(id);
    navigate("/player/menu");
  };

  return (
    <div className="space-y-5">
      <button
        data-testid={PLAYER.btnBack}
        onClick={() => navigate("/player/menu")}
        className="flex items-center gap-1.5 text-sm text-slate-400 hover:text-white transition-colors"
      >
        <ArrowLeft className="w-4 h-4" />
        Menu
      </button>

      <div className="flex items-center gap-3">
        <ListVideo className="w-5 h-5 text-orange-400" />
        <h2 className="text-xl font-bold">Choose playlist</h2>
      </div>

      {playlists.length === 0 ? (
        <div className="bg-[#11141b] border border-white/5 rounded-xl p-8 text-center text-slate-400">
          <p>No playlists assigned to this device.</p>
          <p className="text-xs text-slate-500 mt-1">Ask your provider to assign one.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
          {playlists.map((p) => {
            const isActive = p.id === activePlaylistId;
            return (
              <button
                key={p.id}
                onClick={() => pick(p.id)}
                className={`text-left bg-[#11141b] hover:bg-[#171b25] border rounded-xl p-4 transition-all ${
                  isActive
                    ? "border-orange-500/60 ring-1 ring-orange-500/30"
                    : "border-white/5 hover:border-white/15"
                }`}
              >
                <div className="flex items-start justify-between">
                  <div className="font-semibold truncate pr-2">{p.name}</div>
                  {isActive && <CheckCircle2 className="w-4 h-4 text-orange-400 shrink-0" />}
                </div>
                <div className="text-xs text-slate-400 mt-1">
                  {p.channels_count?.toLocaleString() || 0} items
                </div>
                {p.description && (
                  <div className="text-xs text-slate-500 mt-2 line-clamp-2">{p.description}</div>
                )}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
